(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart-recommendations"]) return;
  try {
    
  class CartRecommendations extends HTMLElement {
    constructor() {
      super();
      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);
        if ( document.querySelectorAll('[data-js-cart-item]').length > 0 ) {
          fetch(this.dataset.url.replace('PRODUCT_ID', document.querySelectorAll('[data-js-cart-item]')[0].dataset.productId))
            .then(response => response.text())
            .then(text => {
              const innerHTML = new DOMParser()
                  .parseFromString(text, 'text/html')
                  .querySelector('cart-recommendations');
              if ( innerHTML && innerHTML.querySelectorAll('.product-item').length > 0 ) {
                this.innerHTML = innerHTML.innerHTML;
                this.querySelectorAll('form').forEach(elm=>{
                  elm.append(elm.querySelector('template').content.cloneNode(true));
                });
              }
            })
            .catch(e => {
              console.error(e);
            });
        }
      }

      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
    }
  }

  customElements.define('cart-recommendations', CartRecommendations);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"] && !window.DesignMode) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();
      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const innerHTML = new DOMParser()
                .parseFromString(text, 'text/html')
                .querySelector('product-recommendations');
            if ( innerHTML && innerHTML.querySelectorAll('.product-item').length > 0 ) {
              this.innerHTML = innerHTML.innerHTML;
              this.querySelectorAll('form').forEach(elm=>{
                elm.append(elm.querySelector('template').content.cloneNode(true));
              });
            }
          })
          .catch(e => {
            console.error(e);
          });
      }

      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();
})();
